const rsEstratoSocial = [
  { value: '0', detalle: 'Bajo-bajo - 1' },
  { value: '1', detalle: 'Bajo - 2' },
  { value: '2', detalle: 'Medio-bajo - 3' },
  { value: '3', detalle: 'Medio - 4' },
  { value: '4', detalle: 'Medio-alto - 5' },
  { value: '5', detalle: 'Alto - 6' },
  { value: '6', detalle: 'No aplica - NA' },
];

export default rsEstratoSocial;
